import React, { useState, useEffect } from 'react';
import { Form, Button, Card, Row, Col, Collapse, Spinner, Table } from 'react-bootstrap';
import { useDropzone } from 'react-dropzone'; // React Dropzone import
import avatarImg from 'assets/img/team/avatar.png';
import cloudUpload from 'assets/img/icons/cloud-upload.svg';
import { useAuthWizardContext } from 'providers/AuthWizardProvider';
import 'react-toastify/dist/ReactToastify.css'; // 추가
import 'safedb/common/css/IniCustomCss.css';
import CheckOutModal from 'components/modal/CheckOutModal';
import { AiFillCloseCircle } from 'react-icons/ai';
import { PiWarningCircle } from 'react-icons/pi';
import {
  handleValueDelete,
  goToParentPath,
  formatDate,
  formatPhoneNumber,
  validatePhoneNumber,
  handlePhoneChange
} from 'components/common/SunnyUtils';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { BsChevronDown, BsChevronUp } from 'react-icons/bs';
import {
  updateCompanyInfo,
  ImagesUpload,
  deleteCompanyInfo,
  fetchPricingPolicies,
  fetchPricingPolicy,
  updateCompanyPricingPolicy,
  fetchImageByUuid
} from 'hooks/CallApi';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretSquareLeft } from '@fortawesome/free-solid-svg-icons';
import { useAppContext } from 'providers/AppProvider';
import styled from 'styled-components';

// UUID 형태인지 판별하는 함수
const isValidUUID = (str) => {
  if (!str || typeof str !== 'string') return false;
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return uuidRegex.test(str);
};

const EditadminSite = () => {
  const {
    config: { userAuth }
  } = useAppContext();

  const [modalDeleteShow, setModalDeleteShow] = useState(false);
  const [modalDeleteCheckShow, setModalDeleteCheckShow] = useState(false);
  const [modalConfirmShow, setModalConfirmShow] = useState(false);
  const [modalConfirmCheckShow, setModalConfirmCheckShow] = useState(false);
  const [isChevronUp, setIsChevronUp] = useState(false); // 상태 변수 추가
  const toggleKeyPart = () => {
    setKeyPart(!KeyPart);
    setIsChevronUp(!isChevronUp); // 아이콘 상태 전환
  };
  const [KeyPart, setKeyPart] = useState(true);
  const [NameError, setNameError] = useState('');
  const [MailError, setMailError] = useState('');
  const [AddrError, setAddrError] = useState('');
  const [NameBlankError, setNameBlankError] = useState(false);
  const [DescError, setDescError] = useState('');
  const [isArrowHovered, setIsArrowHovered] = useState(false);
  const [ErrorCode, setErrorCode] = useState('');
  const [ErrorMsg, setErrorMsg] = useState('');
  const [modalErrorShow, setModalErrorShow] = useState(false);
  const [isUploading, setIsUploading] = useState(false); // 업로드 로딩 상태

  const [isHovered, setIsHovered] = useState(false);
  const handleMouseEnter = () => {
    if (userAuth === 'SA' || userAuth === 'ADMIN') {
      setIsHovered(true);
    }
  };
  const handleMouseLeave = () => setIsHovered(false);
  const [isInvalid, setIsInvalid] = useState(false); // 유효성 검사 상태
  const [PhoneError, setPhoneError] = useState(''); // 연락처 에러 메시지

  const location = useLocation();

  const {
    createdAt,
    updateAt,
    imgUrl,
    active,
    description,
    clientName,
    clientEmail,
    clientPhone,
    clientAddress,
    companyId,
    pricingPolicyUuid,
    pricingPolicyName
  } = location.state || {}; // 추가 데이터 포함

  const initialFormData = {
    createdAt: createdAt,
    updateAt: updateAt,
    clientName: clientName,
    clientEmail: clientEmail,
    clientPhone: clientPhone,
    clientAddress: clientAddress,
    description: description,
    imgUrl: imgUrl,
    active: active,
    clientSecret: '',
    clientKey: '',
    clientIV: '',
    companyId: companyId,
    pricingPolicyUuid: pricingPolicyUuid,
    pricingPolicyName: pricingPolicyName
  };

  const [formData, setFormData] = useState({
    createdAt: createdAt,
    updateAt: updateAt,
    clientName: clientName,
    clientEmail: clientEmail,
    clientPhone: clientPhone,
    clientAddress: clientAddress,
    description: description,
    imgUrl: imgUrl,
    active: active,
    clientSecret: '',
    clientKey: '',
    clientIV: '',
    companyId: companyId,
    pricingPolicyUuid: pricingPolicyUuid,
    pricingPolicyName: pricingPolicyName
  });

  const handleConfirm = async () => {
    try {
      const response = await updateCompanyInfo(formData.companyId, {
        imgUrl: formData.imgUrl,
        name: formData.clientName,
        tel: formData.clientPhone,
        email: formData.clientEmail,
        address: formData.clientAddress,
        description: formData.description
      });

      if (response) {
        setModalConfirmShow(false);
        setModalConfirmCheckShow(true);
      } else {
        // toast.error('회사 정보 업데이트가 실패했습니다.');
        alert('회사 정보 업데이트가 실패했습니다.');
      }
    } catch (error) {
      // toast.error('회사 정보 업데이트 중 오류가 발생했습니다.');
      alert('회사 정보 업데이트 중 오류가 발생했습니다.');
    }
  };

  const handleDelete = async () => {
    try {
      await deleteCompanyInfo(formData.companyId); // 삭제 API 호출
      setModalDeleteCheckShow(true); // 삭제 확인 모달
    } catch (error) {
      setErrorCode(error.response.data.code);
      setErrorMsg(error.response.data.message);
      setModalErrorShow(true);
    }
  };

  const navigate = useNavigate(); // useNavigate 훅 사용

  const { user } = useAuthWizardContext();

  const [avatar, setAvatar] = useState([{ src: imgUrl || avatarImg }]);

  // 초기 상태 설정
  useEffect(() => {
    const initialAvatar = imgUrl && imgUrl.trim() !== '' ? imgUrl : avatarImg;
    setAvatar([{ src: initialAvatar }]);
  }, [imgUrl]);

  // UUID 이미지 처리 (기존 로직과 독립적)
  useEffect(() => {
    if (!imgUrl || !imgUrl.trim() || !isValidUUID(imgUrl)) {
      return; // UUID가 아니면 처리하지 않음
    }

    const loadUuidImage = async () => {
      try {
        const imageUrl = await fetchImageByUuid(imgUrl);
        if (imageUrl) {
          setAvatar([{ src: imageUrl }]);
        }
      } catch (error) {
        console.warn('UUID 이미지 로딩 실패, 기존 이미지 유지:', error);
        // 실패해도 기존 이미지 유지
      }
    };

    // 기본 이미지 로딩 후 UUID 처리
    const timeoutId = setTimeout(loadUuidImage, 200);
    return () => clearTimeout(timeoutId);
  }, [imgUrl]);

  const handleChange = e => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value
    });

    // 각각의 에러
    if (name === 'clientEmail') {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(value)) {
        setMailError('올바른 이메일 형식이 아닙니다.');
      } else if (value.length >= 50) {
        setMailError('고객사 메일은 최대 50자까지 입력 가능합니다.');
      } else {
        setMailError('');
      }
    }

    if (name === 'clientName') {
      if (value.length >= 50) {
        setNameError(`고객사명은 최대 50자까지 입력 가능합니다.`);
      } else {
        setNameError('');
      }
    }

    if (name === 'clientAddress') {
      if (value.length >= 100) {
        setAddrError(`고객사 주소는 최대 100자까지 입력 가능합니다.`);
      } else {
        setAddrError('');
      }
    }

    if (name === 'description') {
      if (value.length >= 800) {
        setDescError(`고객사 설명란 입력은 최대 800자까지 입력 가능합니다.`);
      } else {
        setDescError('');
      }
    }

    if (name === 'clientPhone') {
      handlePhoneChange(value, formData, setFormData, setPhoneError, setIsInvalid);
      return; // 다른 입력 필드 검사를 건너뛴다.
    }
  };



  const onDrop = async acceptedFiles => {
    if (userAuth === 'SA' || userAuth === 'ADMIN') {
      if (acceptedFiles.length > 0 && !isUploading) { // 업로드 중이 아닐 때만 처리
        const imageFile = acceptedFiles[0];
        const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB
        if (imageFile.size > MAX_FILE_SIZE) {
          alert('이미지 크기는 최대 5MB까지 허용됩니다.');
          return;
        }

        // 업로드 시작
        setIsUploading(true);

        // 미리보기 URL을 try 블록 밖에서 선언
        let previewUrl;

        try {
          // 미리보기 즉시 반영
          previewUrl = URL.createObjectURL(imageFile);
          setAvatar([{ src: previewUrl }]);

          // API 업로드 실행
          const uploadResponse = await ImagesUpload(imageFile, 'company');

          if (uploadResponse && uploadResponse.data.imageUrl) {
            const uploadedImageUrl = uploadResponse.data.imageUrl;

            // formData 업데이트
            setFormData(prev => ({
              ...prev,
              imgUrl: uploadedImageUrl
            }));

            // UUID인지 확인하고 적절히 처리
            if (isValidUUID(uploadedImageUrl)) {
              // UUID라면 fetchImageByUuid로 Blob URL 가져와서 표시
              try {
                const blobUrl = await fetchImageByUuid(uploadedImageUrl);
                if (blobUrl) {
                  setAvatar([{ src: blobUrl }]);
                } else {
                  // fetchImageByUuid 실패 시 미리보기 유지
                  console.warn('UUID 이미지 로딩 실패, 미리보기 유지');
                }
              } catch (error) {
                console.warn('UUID 이미지 로딩 실패, 미리보기 유지:', error);
              }
            } else {
              // 일반 URL이라면 직접 사용
              setAvatar([{ src: uploadedImageUrl }]);
            }

            // 미리보기 URL 정리 (메모리 누수 방지)
            URL.revokeObjectURL(previewUrl);

            // setIsChanged(true); // Mark as changed
          } else {
            throw new Error('이미지 업로드에 실패했습니다.');
          }
        } catch (error) {
          console.error('이미지 업로드 에러:', error);
          alert('이미지 업로드에 실패했습니다.');
          // 에러 발생 시에도 미리보기 URL 정리 (존재하는 경우에만)
          if (previewUrl) {
            URL.revokeObjectURL(previewUrl);
          }
        } finally {
          // 업로드 완료 (성공/실패 무관)
          setIsUploading(false);
        }
      }
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: {
      'image/jpeg': ['.jpeg', '.jpg'],
      'image/png': ['.png'],
      'image/gif': ['.gif'],
      'image/svg+xml': ['.svg']
    },
    disabled: !(userAuth === 'SA' || userAuth === 'ADMIN') || isUploading // Dropzone 비활성화 (권한 없거나 업로드 중일 때)
  });

  const isFormValid = () => {
    const requiredFields = ['clientName', 'clientEmail', 'clientAddress'];
    const allRequiredFieldsFilled = requiredFields.every(
      field => formData[field] && formData[field].trim && formData[field].trim().length > 0
    );

    const phoneValidation = validatePhoneNumber(formData.clientPhone);
    const phoneRequiredFieldsFilled = formData.clientPhone && formData.clientPhone.trim && formData.clientPhone.trim().length > 0;

    // 중요한 필드들만 비교
    const importantFields = ['clientName', 'clientEmail', 'clientPhone', 'clientAddress', 'description', 'imgUrl'];
    const isFormChanged = importantFields.some(
      key => formData[key] !== initialFormData[key]
    );

    return (
      allRequiredFieldsFilled &&
      phoneRequiredFieldsFilled &&
      phoneValidation.isValid &&
      isFormChanged
    );
  };

  // New states for pricing policy editor
  const [editingPolicy, setEditingPolicy] = useState(false);
  const [policyOptions, setPolicyOptions] = useState([]);
  const [loadingPolicies, setLoadingPolicies] = useState(false);
  const [selectedPolicyUuid, setSelectedPolicyUuid] = useState('');
  const [modalPolicyConfirmShow, setModalPolicyConfirmShow] = useState(false);

  // New states for pricing policy details
  const [showPolicyDetails, setShowPolicyDetails] = useState(false);
  const [policyDetails, setPolicyDetails] = useState(null);
  const [loadingPolicyDetails, setLoadingPolicyDetails] = useState(false);

  // Function to toggle policy editing mode
  const togglePolicyEdit = async () => {
    if (!editingPolicy) {
      // Entering edit mode - load policy options
      setLoadingPolicies(true);
      try {
        // This would be replaced with actual API call in production
        const response = await fetchPricingPolicies(0, 100); // Fetch all policies
        if (response && response.data && response.data.content) {
          setPolicyOptions(response.data.content);
        }
        setSelectedPolicyUuid(formData.pricingPolicyUuid || '');

        // Collapse policy details when entering edit mode
        setShowPolicyDetails(false);
        setPolicyDetails(null);
      } catch (error) {
        console.error('요금정책 목록 로딩 실패:', error);
        setErrorMsg('요금정책 목록을 불러오는데 실패했습니다.');
        setModalErrorShow(true);
      } finally {
        setLoadingPolicies(false);
      }
    }
    setEditingPolicy(!editingPolicy);
  };

  // Handle policy selection change
  const handlePolicyChange = e => {
    const selectedUuid = e.target.value;
    setSelectedPolicyUuid(selectedUuid);

    // Find the selected policy name from options
    const selectedPolicy = policyOptions.find(
      policy => policy.pricingPolicyUuid === selectedUuid
    );

    if (selectedPolicy && selectedPolicy.pricingPolicyName !== formData.pricingPolicyName) {
      // Show confirmation modal only if the policy changed
      setModalPolicyConfirmShow(true);
    }
  };

  // Function to apply the pricing policy change
  const applyPolicyChange = async () => {
    // Close confirmation modal
    setModalPolicyConfirmShow(false);

    try {
      // 요금정책 변경이 실제로 이루어졌는지 확인
      if (selectedPolicyUuid !== formData.pricingPolicyUuid) {
        // 요금정책 변경 API 호출
        const response = await updateCompanyPricingPolicy(
          formData.companyId,
          formData.pricingPolicyUuid || null, // 이전 정책 UUID (없으면 null)
          selectedPolicyUuid // 새로운 정책 UUID
        );

        if (response && response.data) {
          // API 응답에서 반환된 고객사 정보로 폼 데이터 업데이트
          const updatedCompany = response.data;

          setFormData({
            ...formData,
            pricingPolicyUuid: updatedCompany.pricingPolicyUuid,
            pricingPolicyName: updatedCompany.pricingPolicyName
          });

          // 성공 메시지 표시
          setErrorMsg('요금정책이 성공적으로 변경되었습니다.');
          setModalErrorShow(true);
        } else {
          throw new Error('요금정책 변경 응답 데이터가 유효하지 않습니다.');
        }
      }

      // Reset policy details when policy is changed
      setShowPolicyDetails(false);
      setPolicyDetails(null);

      // Exit edit mode
      setEditingPolicy(false);
    } catch (error) {
      console.error('요금정책 변경 실패:', error);

      // 에러 메시지 설정
      const errorMessage = error.response?.data?.message || '요금정책 변경에 실패했습니다.';
      setErrorMsg(errorMessage);
      setModalErrorShow(true);

      // 편집 모드 유지
      setEditingPolicy(true);
    }
  };

  // Cancel policy change
  const cancelPolicyChange = () => {
    setModalPolicyConfirmShow(false);
    setSelectedPolicyUuid(formData.pricingPolicyUuid || '');
    setEditingPolicy(false);
  };

  // Function to fetch pricing policy details
  const handleViewPolicyDetails = async () => {
    if (!formData.pricingPolicyUuid) {
      setErrorMsg("적용된 요금정책이 없습니다.");
      setModalErrorShow(true);
      return;
    }

    // Toggle the collapsed state
    if (showPolicyDetails && policyDetails) {
      setShowPolicyDetails(false);
      return;
    }

    // Show the collapse section and start loading
    setShowPolicyDetails(true);
    setLoadingPolicyDetails(true);

    try {
      const response = await fetchPricingPolicy(formData.pricingPolicyUuid);

      if (response && response.data) {
        setPolicyDetails(response.data);
      } else {
        throw new Error("요금정책 정보를 가져오는데 실패했습니다.");
      }
    } catch (error) {
      console.error("요금정책 정보 로딩 에러:", error);
      setErrorMsg(error.response?.data?.message || "요금정책 정보를 가져오는데 실패했습니다.");
      setModalErrorShow(true);
      setShowPolicyDetails(false);
    } finally {
      setLoadingPolicyDetails(false);
    }
  };

  // Formatter for currency amounts
  const formatCurrency = (amount) => {
    if (amount === undefined || amount === null) return '-';
    return new Intl.NumberFormat('ko-KR', { style: 'currency', currency: 'KRW' }).format(amount);
  };

  return (
    <div className="container mt-5">
      {/* Main customer details card */}
      <Card className="mypage-card">
        <Card.Header className="px-3" as="h4">
          <Link
            to={goToParentPath()}
            style={{ textDecoration: 'none', color: 'inherit' }}
            onMouseEnter={() => setIsArrowHovered(true)}
            onMouseLeave={() => setIsArrowHovered(false)}
          >
            <FontAwesomeIcon
              icon={faCaretSquareLeft}
              className="me-2"
              style={
                isArrowHovered
                  ? {} // Hover 시 스타일 제거
                  : { color: '#869fca' } // 기본 스타일
              }
            />
          </Link>
          고객사 관리
        </Card.Header>

        <Card.Title className=" px-3 pt-3"> 상세 정보</Card.Title>
        <Card.Body>
          <Form
            onSubmit={e => {
              e.preventDefault();
              setModalConfirmShow(true);
            }}
          >
            <Row>
              {/* Left Column (Profile Image) */}
              <Col md={4} className="text-center profile-section">
                <div
                  {...getRootProps({ className: 'dropzone' })}
                  style={{
                    cursor: isUploading
                      ? 'not-allowed'
                      : (userAuth === 'SA' || userAuth === 'ADMIN' ? 'pointer' : 'not-allowed'),
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '150px',
                    height: '150px',
                    position: 'relative',
                    margin: '0 auto',
                    opacity: isUploading ? 0.7 : 1
                  }}
                  onMouseEnter={handleMouseEnter}
                  onMouseLeave={handleMouseLeave}
                >
                  <input {...getInputProps()} />

                  {isUploading ? (
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px' }}>
                      <Spinner animation="border" size="sm" />
                      <small style={{ color: '#6c757d' }}>업로드 중...</small>
                    </div>
                  ) : (
                    <Profile>
                      <Image
                        src={avatar.length > 0 ? avatar[0].src : cloudUpload}
                        alt=""
                      />
                      <HoverView>이미지 변경</HoverView>
                    </Profile>
                  )}
                </div>
              </Col>

              {/* Right Column (ID, Password, Name) */}
              <Col md={8}>
                <Row>
                  <Col>
                    <Form.Group
                      className="mb-3"
                      style={{ position: 'relative' }}
                    >
                      <Form.Label>
                        고객사명<span className="text-danger">*</span>
                      </Form.Label>
                      <div
                        style={{
                          position: 'relative'
                        }}
                      >
                        <Form.Control
                          type="text"
                          name="clientName"
                          value={formData.clientName}
                          onChange={handleChange}
                          className="input-hover"
                          maxLength="50"
                        />
                        {formData.clientName && (
                          <span
                            onClick={e => {
                              handleValueDelete(
                                'clientName',
                                formData,
                                setFormData
                              );
                              handleChange({
                                target: { name: 'clientName', value: '' }
                              }); // handleChange를 직접 호출
                            }}
                            style={{
                              cursor: 'pointer',
                              position: 'absolute',
                              right: '10px',
                              top: '52%',
                              transform: 'translateY(-14px)',
                              zIndex: 9
                            }}
                          >
                            <AiFillCloseCircle />
                          </span>
                        )}
                      </div>
                    </Form.Group>
                    {NameError && (
                      <span className="text-danger">{NameError}</span>
                    )}{' '}
                    {/* 에러 메시지 표시 */}
                  </Col>
                  <Col>
                    <Form.Group
                      className="mb-3"
                      style={{ position: 'relative' }}
                    >
                      <Form.Label>
                        고객사 연락처<span className="text-danger">*</span>
                      </Form.Label>
                      <div
                        style={{
                          position: 'relative'
                        }}
                      >
                        <Form.Control
                          type="phone"
                          name="clientPhone"
                          value={formData.clientPhone}
                          onChange={handleChange}
                          className="input-hover"
                          maxLength="20"
                        />
                        {formData.clientPhone && (
                          <span
                            onClick={e =>
                              handleValueDelete(
                                'clientPhone',
                                formData,
                                setFormData
                              )
                            }
                            style={{
                              cursor: 'pointer',
                              position: 'absolute',
                              right: '10px',
                              top: '50%',
                              transform: 'translateY(-14px)',
                              zIndex: 9
                            }}
                          >
                            <AiFillCloseCircle />
                          </span>
                        )}
                      </div>
                    </Form.Group>
                    {PhoneError && (
                      <span className="text-danger">{PhoneError}</span>
                    )}{' '}
                    {/* 에러 메시지 표시 */}
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      className="mb-3"
                      style={{ position: 'relative' }}
                    >
                      <Form.Label>
                        고객사 메일<span className="text-danger">*</span>
                      </Form.Label>
                      <div
                        style={{
                          position: 'relative'
                        }}
                      >
                        <Form.Control
                          type="text"
                          name="clientEmail"
                          value={formData.clientEmail}
                          onChange={handleChange}
                          className="input-hover"
                          maxLength="50"
                        />
                        {formData.clientEmail && (
                          <span
                            onClick={e =>
                              handleValueDelete(
                                'clientEmail',
                                formData,
                                setFormData
                              )
                            }
                            style={{
                              cursor: 'pointer',
                              position: 'absolute',
                              right: '10px',
                              top: '52%',
                              transform: 'translateY(-14px)',
                              zIndex: 9
                            }}
                          >
                            <AiFillCloseCircle />
                          </span>
                        )}
                      </div>
                    </Form.Group>
                    {MailError && (
                      <span className="text-danger">{MailError}</span>
                    )}{' '}
                    {/* 에러 메시지 표시 */}
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      className="mb-3"
                      style={{ position: 'relative' }}
                    >
                      <Form.Label>
                        고객사 주소<span className="text-danger">*</span>
                      </Form.Label>
                      <div
                        style={{
                          position: 'relative'
                        }}
                      >
                        <Form.Control
                          type="text"
                          name="clientAddress"
                          value={formData.clientAddress}
                          onChange={handleChange}
                          className="input-hover"
                          maxLength="100"
                        />
                        {formData.clientAddress && (
                          <span
                            onClick={e =>
                              handleValueDelete(
                                'clientAddress',
                                formData,
                                setFormData
                              )
                            }
                            style={{
                              cursor: 'pointer',
                              position: 'absolute',
                              right: '10px',
                              top: '52%',
                              transform: 'translateY(-14px)',
                              zIndex: 9
                            }}
                          >
                            <AiFillCloseCircle />
                          </span>
                        )}
                      </div>
                    </Form.Group>
                    {AddrError && (
                      <span className="text-danger">{AddrError}</span>
                    )}{' '}
                    {/* 에러 메시지 표시 */}
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>등록 일시</Form.Label>
                      <Form.Control
                        type="text"
                        name="addDate"
                        value={formatDate(formData.createdAt)}
                        disabled
                        readOnly
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>수정 일시</Form.Label>
                      <Form.Control
                        type="text"
                        name="editDate"
                        value={formatDate(formData.updateAt)}
                        readOnly
                        disabled
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <div style={{ display: 'none' }}>
                  <div
                    style={{
                      width: '100%',
                      backgroundColor: 'lightgray',
                      display: 'flex',
                      justifyContent: 'space-between'
                    }}
                  >
                    <span>
                      <h5>[{formData.clientName}] KEY 관리</h5>
                    </span>
                    <button
                      style={{ border: 'none', backgroundColor: 'transparent' }}
                      onClick={toggleKeyPart} // 상태 변경 함수 호출
                    >
                      {isChevronUp ? <BsChevronDown /> : <BsChevronUp />}{' '}
                      {/* 아이콘 상태에 따라 표시 */}
                    </button>
                  </div>
                  {KeyPart && (
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        border: '2px',
                        borderStyle: 'dashed'
                      }}
                      className="p-2"
                    >
                      <div style={{ flexGrow: 1 }} className="mb-4">
                        <Row className="align-items-center">
                          <Col md={9}>
                            <Form.Group
                              className="mb-3"
                              style={{ position: 'relative' }}
                            >
                              <Form.Label>
                                [{formData.clientName}] SECRET
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="clientSecret"
                                value={formData.clientSecret}
                                onChange={handleChange}
                                readOnly
                              />
                            </Form.Group>
                          </Col>
                          <Col md={3}>
                            <Form.Group className="mb-3">
                              <Form.Label style={{ opacity: 0 }}>
                                버튼
                              </Form.Label>
                              <Button variant="secondary " className="w-100">
                                SECRET 재발급
                              </Button>
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row className="align-items-center">
                          <Col md={9}>
                            <Form.Group
                              className="mb-3"
                              style={{ position: 'relative' }}
                            >
                              <Form.Label>암호용 KEY</Form.Label>
                              <Form.Control
                                type="text"
                                name="clientKey"
                                value={formData.clientKey}
                                onChange={handleChange}
                                readOnly
                              />
                            </Form.Group>
                          </Col>
                          <Col md={3}>
                            <Form.Group
                              className="mb-3"
                              style={{ position: 'relative' }}
                            >
                              <Form.Label style={{ opacity: 0 }}>
                                버튼
                              </Form.Label>
                              <Button
                                variant="secondary "
                                className="w-100 p-0"
                                style={{ height: 36, fontSize: 16 }}
                              >
                                암호용KEY/Ⅳ 재발급
                              </Button>
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={9}>
                            <Form.Group
                              className="mb-3"
                              style={{ position: 'relative' }}
                            >
                              <Form.Label>암호용 Ⅳ</Form.Label>
                              <Form.Control
                                type="text"
                                name="clientIV"
                                value={formData.clientIV}
                                onChange={handleChange}
                                readOnly
                              />
                            </Form.Group>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  )}
                </div>

                <Form.Group className="mb-3" style={{ position: 'relative' }}>
                  <Form.Label>설명</Form.Label>
                  <div
                    style={{
                      position: 'relative'
                    }}
                  >
                    <Form.Control
                      as="textarea"
                      name="description"
                      rows={3}
                      value={formData.description}
                      onChange={handleChange}
                      className="input-hover"
                      maxLength="800"
                    />
                    {formData.description && (
                      <span
                        onClick={e =>
                          handleValueDelete(
                            'description',
                            formData,
                            setFormData
                          )
                        }
                        style={{
                          cursor: 'pointer',
                          position: 'absolute',
                          right: '10px',
                          top: '50%',
                          transform: 'translateY(-14px)',
                          zIndex: 9
                        }}
                      >
                        <AiFillCloseCircle />
                      </span>
                    )}
                  </div>
                  {DescError && <div style={{ color: 'red' }}>{DescError}</div>}{' '}
                  {/* 에러 메시지 표시 */}
                </Form.Group>
              </Col>
            </Row>

            {/* 키영역 복구 시 pt 빼도됨*/}
            <div className="d-flex justify-content-between mt-3 pt-8">
              <Button
                variant="outline-danger"
                onClick={() => setModalDeleteShow(true)}
                style={{ width: '7rem' }}
              >
                삭제
              </Button>
              <div>
                <Button
                  variant="primary"
                  type="submit"
                  disabled={!isFormValid()}
                  style={{ width: '7rem' }}
                >
                  변경
                </Button>
              </div>
            </div>
          </Form>
        </Card.Body>
      </Card>

      {/* Pricing Policy Card */}
      <Card className="mt-3">
        <Card.Header as="h5">요금정책 정보</Card.Header>
        <Card.Body>
          <Form>
            <Row>
              <Col>
                <div className="d-flex align-items-center">
                  <Form.Group className="mb-3 flex-grow-1">
                    <Form.Label>요금정책명</Form.Label>
                    {editingPolicy ? (
                      <div className="position-relative">
                        {loadingPolicies ? (
                          <div className="d-flex align-items-center p-2 bg-light">
                            <div
                              className="spinner-border spinner-border-sm me-2"
                              role="status"
                            >
                              <span className="visually-hidden">Loading...</span>
                            </div>
                            <span>요금정책 목록 로딩 중...</span>
                          </div>
                        ) : (
                          <Form.Select
                            value={selectedPolicyUuid}
                            onChange={handlePolicyChange}
                          >
                            <option value="">적용된 요금정책 없음</option>
                            {policyOptions.map(policy => (
                              <option
                                key={policy.pricingPolicyUuid}
                                value={policy.pricingPolicyUuid}
                              >
                                {policy.pricingPolicyName}
                              </option>
                            ))}
                          </Form.Select>
                        )}
                      </div>
                    ) : (
                      <Form.Control
                        type="text"
                        value={
                          formData.pricingPolicyName || '적용된 요금정책 없음'
                        }
                        disabled
                        readOnly
                        className="bg-light"
                      />
                    )}
                  </Form.Group>

                  {userAuth === 'SA' && (
                    <Button
                      variant={editingPolicy ? 'secondary' : 'outline-primary'}
                      className="ms-2 align-self-end mb-3"
                      onClick={togglePolicyEdit}
                      style={{ width: '5rem' }}
                    >
                      {editingPolicy ? '취소' : '변경'}
                    </Button>
                  )}
                </div>
              </Col>
            </Row>

            {/* Add "View Details" button */}
            {!editingPolicy && formData.pricingPolicyUuid && (
              <Row>
                <Col>
                  <Button
                    variant="outline-info"
                    size="sm"
                    onClick={handleViewPolicyDetails}
                    disabled={loadingPolicyDetails}
                    className="mb-3"
                  >
                    {showPolicyDetails ? '상세 정보 접기' : '상세 정보 보기'}
                  </Button>
                </Col>
              </Row>
            )}

            {/* Collapsible Policy Details Section */}
            <Collapse in={showPolicyDetails}>
              <div>
                {loadingPolicyDetails ? (
                  <div className="text-center py-4">
                    <Spinner animation="border" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </Spinner>
                    <p className="mt-2">요금정책 정보를 로딩 중입니다...</p>
                  </div>
                ) : policyDetails ? (
                  <div className="policy-details border rounded p-3 bg-light">
                    <h6 className="border-bottom pb-2 mb-3">정책 기본 정보</h6>
                    <Row className="mb-3">
                      <Col md={6}>
                        <Form.Group>
                          <Form.Label>정책명</Form.Label>
                          <Form.Control
                            type="text"
                            value={policyDetails.pricingPolicyName || '-'}
                            readOnly
                            disabled
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group>
                          <Form.Label>설명</Form.Label>
                          <Form.Control
                            type="text"
                            value={policyDetails.description || '-'}
                            readOnly
                            disabled
                          />
                        </Form.Group>
                      </Col>
                    </Row>

                    {policyDetails.serviceGroupList && policyDetails.serviceGroupList.length > 0 ? (
                      <>
                        <h6 className="border-bottom pb-2 mb-3 mt-4">서비스 구성</h6>
                        {policyDetails.serviceGroupList.map((group, index) => (
                          <div key={index} className="service-group mb-4 border rounded p-3 bg-white">
                            <h6>서비스 그룹: {group.serviceItemName || '-'}</h6>

                            {group.servicePriceList && group.servicePriceList.length > 0 ? (
                              <>
                                {group.servicePriceList.map((servicePrice, priceIndex) => (
                                  <div key={priceIndex} className="service-price ms-3 mb-3">
                                    <p className="mb-2 mt-3"><strong>서비스 항목:</strong> {servicePrice.serviceItemName || '-'}</p>
                                    <Row className="mb-2">
                                      <Col md={6}>
                                        <Form.Group>
                                          <Form.Label>기본 가격</Form.Label>
                                          <Form.Control
                                            type="text"
                                            value={formatCurrency(servicePrice.price)}
                                            readOnly
                                            disabled
                                          />
                                        </Form.Group>
                                      </Col>
                                      <Col md={6}>
                                        <Form.Group>
                                          <Form.Label>결제 단위</Form.Label>
                                          <Form.Control
                                            type="text"
                                            value={servicePrice.paymentUnit || '-'}
                                            readOnly
                                            disabled
                                          />
                                        </Form.Group>
                                      </Col>
                                    </Row>

                                    {servicePrice.serviceTierPriceList && servicePrice.serviceTierPriceList.length > 0 && (
                                      <div className="tier-pricing mt-3">
                                        <h6 className="mb-2">구간 가격 정보</h6>
                                        <Table bordered hover size="sm" className="fs-10">
                                          <thead className="bg-light">
                                            <tr>
                                              <th>시작 수량</th>
                                              <th>종료 수량</th>
                                              <th>할인 수치</th>
                                              <th>할인 단위</th>
                                              <th>적용 가격</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {servicePrice.serviceTierPriceList.map((tier, tierIndex) => {
                                              // 백엔드에서 계산된 할인 적용 단가 사용 (PricingPolicyService.enrichTierAppliedPrice)
                                              const discountedPrice = tier.appliedPrice != null ? tier.appliedPrice : servicePrice.price;
                                              return (
                                                <tr key={tierIndex}>
                                                  <td>{tier.startAmount}</td>
                                                  <td>{tier.endAmount}</td>
                                                  <td>{tier.discountAmount}</td>
                                                  <td>{tier.discountUnit === 'percent' ? '%' : '원'}</td>
                                                  <td>{formatCurrency(discountedPrice)}</td>
                                                </tr>
                                              );
                                            })}
                                          </tbody>
                                        </Table>
                                      </div>
                                    )}
                                    {priceIndex < group.servicePriceList.length - 1 && (
                                      <hr className="my-3" />
                                    )}
                                  </div>
                                ))}
                              </>
                            ) : (
                              <p className="ms-3 text-muted">서비스 가격 정보가 없습니다.</p>
                            )}
                          </div>
                        ))}
                      </>
                    ) : (
                      <p className="text-muted">서비스 구성 정보가 없습니다.</p>
                    )}
                  </div>
                ) : (
                  <p className="text-danger">요금정책 정보를 불러올 수 없습니다.</p>
                )}
              </div>
            </Collapse>
          </Form>
        </Card.Body>
      </Card>

      <CheckOutModal
        show={modalDeleteShow}
        onHide={() => setModalDeleteShow(false)}
        onConfirm={handleDelete}
        title="경고"
        variant="warning"
        body="선택하신 고객사에 대한 모든 설정값 및 권한 정보가 삭제됩니다. 정말 삭제하시겠습니까?"
        cancelText="취소"
        confirmText="확인"
        CancelButton={true}
        SubmitButton={true}
      />
      <CheckOutModal
        show={modalDeleteCheckShow}
        onHide={() => {
          setModalDeleteShow(false);
          setModalDeleteCheckShow(false);
        }}
        variant="success"
        onConfirm={() => {
          setModalDeleteShow(false);
          setModalDeleteCheckShow(false);
          navigate(`/safedb/SA/adminSites`);
        }}
        title="확인" // 제목
        confirmText="확인"
        body="삭제가 완료되었습니다." // 본문 내용
        SubmitButton={true}
      />
      <CheckOutModal
        show={modalConfirmShow}
        onHide={() => setModalConfirmShow(false)}
        onConfirm={handleConfirm}
        title="확인"
        variant="info"
        body="고객사 정보를 변경하시겠습니까?"
        cancelText="취소"
        confirmText="확인"
        CancelButton={true}
        SubmitButton={true}
      />

      <CheckOutModal
        show={modalConfirmCheckShow}
        onHide={() => {
          setModalConfirmCheckShow(false);
          navigate(`/safedb/SA/adminSites`);
        }}
        variant="success"
        onConfirm={() => {
          setModalConfirmCheckShow(false);
          navigate(`/safedb/SA/adminSites`);
        }}
        title="완료" // 제목
        body="변경이 완료 되었습니다." // 본문 내용
        confirmText="확인"
        SubmitButton={true}
      />
      <CheckOutModal
        show={modalErrorShow}
        onHide={() => setModalErrorShow(false)}
        onConfirm={() => setModalErrorShow(false)}
        title="알림"
        body={`${ErrorMsg}`}
        cancelText="취소"
        confirmText="확인"
        variant="info"
        SubmitButton={true}
      />
      <CheckOutModal
        show={modalPolicyConfirmShow}
        onHide={cancelPolicyChange}
        onConfirm={applyPolicyChange}
        title="요금정책 변경"
        variant="warning"
        body="선택한 요금정책으로 변경하시겠습니까? 이 변경은 고객사의 요금 체계에 영향을 미칩니다."
        cancelText="취소"
        confirmText="확인"
        CancelButton={true}
        SubmitButton={true}
      />
    </div>
  );
};

export default EditadminSite;

const Profile = styled.div`
  position: relative;
  width: 150px;
  height: 150px;
  border-radius: 50%;
  overflow: hidden;
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

const HoverView = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  color: white;
  transition: all 0.1s;
  background-color: #2229;
  user-select: none;
  opacity: 0;

  &:hover {
    opacity: 1;
  }
`;
